import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ME_URL } from "../../settings/APISetting";
import axiosInstance from "../../config/axiosConfig";

export const fetchMe = createAsyncThunk("fetch-me", async () => {
    const response = await axiosInstance.get(ME_URL);
    return response.data;
});


const currentUserSlice = createSlice({
    name: 'me',
    initialState: {
        me: {
            // Données par défaut pour le test
            username: 'msarr',
            profil: 'ADMIN-PRODUCTION-BILLETTERIE',
            code: 'MS',
            nomComplet: 'Moustapha Sarr'
        },
        fetchMeStatus: ''
    },
    reducers: {

    },

    extraReducers: (builder) => {
        builder.addCase(fetchMe.fulfilled, (state, action) => {
            // Vérifier si la réponse contient une erreur
            if (action.payload.error) {
                // Garder les données par défaut si erreur
                console.log('fetchMe error, keeping default data:', action.payload);
                state.fetchMeStatus = 'error';
            } else {
                state.me = action.payload;
                console.log('fetchMe success:', action.payload);
                state.fetchMeStatus = 'success';
            }
        }).addCase(fetchMe.pending, (state, action) => {
            state.fetchMeStatus = 'loading';
        }).addCase(fetchMe.rejected, (state, action) => {
            console.log('fetchMe rejected, keeping default data:', action);
            state.fetchMeStatus = 'error';
        });
    }
});

export default currentUserSlice;

